<template>
    <div class="post-wrap page-inner">
        <Title v-if="post">
            <h2>
                <!-- <router-link to="/news">News</router-link> -->
                News
            </h2>
            <h3 v-html="post.title.rendered"></h3>
        </Title>

        <Content v-if="post">
            <div class="box" v-html="content"></div>
        </Content>

        <PostNewsletter v-if="post" />

        <div class="list" v-if="posts.length !== 0">
            <Item
                v-for="(item, index) in posts"
                :key="item.id + '-' + index"
                :item="item"
            />
        </div>

        <Loading v-if="$store.state.is_loading" class="static" />
    </div>
</template>

<script>
import GetPreviewUrl from "@/utils/GetPreviewUrl";
import Title from "@/components/ui/Title.vue";
import Content from "@/components/ui/Content.vue";
import Link from "@/components/ui/Link.vue";
import Loading from "@/components/Loading.vue";
import PostNewsletter from "@/components/PostNewsletter.vue";

import { format } from "fecha";
import Item from "@/components/Item2.vue";
export default {
    name: "single-news",

    data() {
        return {
            post: false,
            content: "",
            posts: []
        };
    },

    components: {
        Content,
        Link,
        Item,
        Title,
        Loading,
        PostNewsletter
    },

    props: {
        slug: {
            type: String,
            default: ""
        }
    },

    watch: {
        "$route.params": {
            handler(params) {
                // console.log(this.$route.name);
                this.fetchData(params);
            },
            immediate: true
        }
    },

    methods: {
        strLimit(html) {
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            let str = tmp.textContent || tmp.innerText || "";
            if (str.length > 50) str = str.substring(0, 50);

            return str;
        },

        getPosts(type_id, post_id) {
            let url = `get-news?per_page=6&paged=1&type_id=${type_id}&post_id=${post_id}`;

            this.$ajax.get(url).then(res => {
                this.posts = res.data;
            });
        },

        fetchData() {
            this.$store.state.is_loading = true;

            let api_obj = GetPreviewUrl("news", this.slug);
            this.$ajax
                .get(api_obj.url, api_obj.head)
                .then(res => {
                    if (res.data.length === 0)
                        this.$router.replace("/page/404");
                    let type = "";
                    let image = "";

                    if (res.data[0].types && res.data[0].types.length !== 0) {
                        type = res.data[0].types[0].name + "<br>";
                        this.getPosts(
                            res.data[0].types[0].term_id,
                            res.data[0].id
                        );
                    }

                    if (res.data[0].featured_image) {
                        image = `<div class="wp-caption">
                                <img src="${res.data[0].featured_image.url}">
                                <p class="wp-caption-text">${res.data[0].featured_image.alt}</p>
                            </div>`;
                    }

                    this.content = `
                <div class="info">
                    <p>
                        ${type}
                        ${format(new Date(res.data[0].date), "DD MMMM YYYY")}
                    </p>
                </div>
                ${image}
                ${res.data[0].content.rendered}`;
                    document.title =
                        window.globals.site_title +
                        " — " +
                        this.$decode(res.data[0].title.rendered);
                    this.post = res.data[0];
                    this.$store.state.is_loading = false;
                    // this.date_str = format(new Date(this.post.date), 'DD MMM YYYY');
                })
                .catch(error => {
                    this.$router.replace("/page/404");
                });
        }
    }
};
</script>
<style lang="scss">
.list {
    margin: 0 var(--margin) var(--padding-x3);
}
.post-info {
    margin: var(--padding) 0;
    text-align: center;

    .ui-button {
        margin: 0 auto var(--padding-50) auto;
        text-align: center;
        text-transform: uppercase;
        display: block;
        border-color: var(--black);
        max-width: 26rem;
    }
}

.page-single-news .post-newsletter {
    margin: var(--padding-x2) var(--margin);
}

@media only screen and (max-width: 767px) {
    .page-single-news .post-newsletter {
        margin: var(--padding-x2) 0;
    }
}
</style>
